import React, { useState } from "react";
import api from "../services/api";

export default function PurchaseStateModal({ state, onClose, onPurchased }) {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [receipt, setReceipt] = useState(null);

  if (!state) return null;

  const handlePurchase = async () => {
    setLoading(true);
    setMsg("");
    try {
      const res = await api.post("/states/purchase", { state_id: state.state_id });
      setMsg(res.data.message || "Purchase successful!");
      setReceipt(res.data.receipt);
      setLoading(false);
      onPurchased && onPurchased(state.state_id);
    } catch (err) {
      setMsg(err?.response?.data?.message || "Purchase failed.");
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal" role="dialog" aria-modal="true">
        <h2>Purchase State Access</h2>
        <p>
          <strong>{state.state_name}</strong>
          <br />
          {state.question_count} questions available.
        </p>
        {state.price !== undefined && (
          <p>Price: <strong>{state.price === 0 ? "Free" : `$${state.price}`}</strong></p>
        )}

        {receipt ? (
          <div style={{ margin: "18px 0 0" }}>
            <h3 style={{ fontSize: 18 }}>Receipt</h3>
            <p><strong>State:</strong> {receipt.state_name}</p>
            <p><strong>Price:</strong> {receipt.price === 0 ? "Free" : `$${receipt.price}`}</p>
            <p><strong>Date:</strong> {new Date(receipt.purchased_at).toLocaleString()}</p>
            <p><strong>Transaction ID:</strong> {receipt.transaction_id}</p>
            <button className="action-button" style={{ marginTop: 14 }} onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <div style={{ marginTop: 20 }}>
            <button onClick={handlePurchase} disabled={loading} className="action-button">
              {loading ? "Processing..." : "Confirm Purchase"}
            </button>
            <button onClick={onClose} disabled={loading} style={{ marginLeft: 10 }}>
              Cancel
            </button>
          </div>
        )}

        {msg && <div className="toast toast-info" style={{ marginTop: 10 }}>{msg}</div>}
      </div>
    </div>
  );
}
